import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	integrationsTitleNonFinal: {
		id: 'eoc-changeboarding.transition-home.deprecated-ones-step.integrations-title-non-final',
		defaultMessage: 'Integrations',
		description: 'Transition home deprecated features step integrations',
	},
	integrationsDescriptionNonFinal: {
		id: 'eoc-changeboarding.transition-home.deprecated-ones-step.integrations-description-non-final',
		defaultMessage:
			'{deprecatedIntegrationCount, plural, one {{deprecatedIntegrationCount} integration} other {{deprecatedIntegrationCount} integrations}} weren’t shifted as they’re not supported by Jira Service Management.',
		description: 'Transition home deprecated features step integrations description',
	},
	groupsTitleNonFinal: {
		id: 'eoc-changeboarding.transition-home.deprecated-ones-step.groups-title-non-final',
		defaultMessage: 'Groups',
		description: 'Transition home deprecated features step groups',
	},
	groupsDescriptionNonFinal: {
		id: 'eoc-changeboarding.transition-home.deprecated-ones-step.groups-description-non-final',
		defaultMessage:
			"{deprecatedGroupCount, plural, one {{deprecatedGroupCount} group} other {{deprecatedGroupCount} groups}} in Opsgenie weren't shifted as they’re now deprecated. You can recreate these groups as teams in Jira Service Management instead.",
		description: 'Transition home deprecated features step groups description',
	},
	heartbeatsTitleNonFinal: {
		id: 'eoc-changeboarding.transition-home.deprecated-ones-step.heartbeats-title-non-final',
		defaultMessage: 'Heartbeats (V1)',
		description: 'Transition home deprecated features step heartbeats',
	},
	heartbeatsDescriptionNonFinal: {
		id: 'eoc-changeboarding.transition-home.deprecated-ones-step.heartbeats-description-non-final',
		defaultMessage:
			"{deprecatedGlobalHeartbeatCount, plural, one {{deprecatedGlobalHeartbeatCount} heartbeat} other {{deprecatedGlobalHeartbeatCount} heartbeats}} in Opsgenie weren't shifted as they’re now deprecated. To shift them to Jira Service Management, update to the latest version.",
		description: 'Transition home deprecated features step heartbeats description',
	},
	teamsApiTitleNonFinal: {
		id: 'eoc-changeboarding.transition-home.deprecated-ones-step.teams-api-title-non-final',
		defaultMessage: 'Teams API',
		description: 'Transition home deprecated features step teams API',
	},
	teamsApiDescriptionNonFinal: {
		id: 'eoc-changeboarding.transition-home.deprecated-ones-step.teams-api-description-non-final',
		defaultMessage:
			'The Teams Opsgenie API doesn’t work with Jira Service Management. You can use the alternative Jira Cloud Platform API.',
		description: 'Transition home deprecated features step teams API description',
	},
	incidentTemplatesTitleNonFinal: {
		id: 'eoc-changeboarding.transition-home.deprecated-ones-step.incident-templates-title-non-final',
		defaultMessage: 'Incident templates',
		description: 'Transition home deprecated features step incident templates',
	},
	incidentTemplatesDescriptionNonFinal: {
		id: 'eoc-changeboarding.transition-home.deprecated-ones-step.incident-templates-description-non-final',
		defaultMessage:
			'Incident templates aren’t supported by Jira Service Management, so they weren’t shifted. You can use incident request types instead.',
		description: 'Transition home deprecated features step incident templates description',
	},
	iccAndBridgesTitleNonFinal: {
		id: 'eoc-changeboarding.transition-home.deprecated-ones-step.icc-and-bridges-title-non-final',
		defaultMessage: 'Incident Command Center and Conference Bridges',
		description: 'Transition home deprecated features step ICC and bridges',
	},
	iccAndBridgesDescriptionNonFinal: {
		id: 'eoc-changeboarding.transition-home.deprecated-ones-step.icc-and-bridges-description-non-final',
		defaultMessage:
			'The Incident Command Center and Conference Bridges aren’t supported by Jira Service Management. You can use the Slack, Microsoft Teams, and Zoom apps instead.',
		description: 'Transition home deprecated features step ICC and bridges description',
	},
	notificationPoliciesTitleNonFinal: {
		id: 'eoc-changeboarding.transition-home.deprecated-ones-step.notification-policies-title-non-final',
		defaultMessage: 'Notification policies (V1)',
		description: 'Transition home deprecated features step notification policies',
	},
	notificationPoliciesDescriptionNonFinal: {
		id: 'eoc-changeboarding.transition-home.deprecated-ones-step.notification-policies-description-non-final',
		defaultMessage:
			"{deprecatedNotificationPolicyCount, plural, one {{deprecatedNotificationPolicyCount} notification policy wasn't} other {{deprecatedNotificationPolicyCount} notification policies weren't}} shifted as they’re now deprecated. To shift them to Jira Service Management, update to the latest version.",
		description: 'Transition home deprecated features step notification policies description',
	},
	actionsAndIncidentRulesTitleNonFinal: {
		id: 'eoc-changeboarding.transition-home.deprecated-ones-step.actions-and-incident-rules-title-non-final',
		defaultMessage: 'Actions and incident rules',
		description: 'Transition home deprecated features step actions and incident rules',
	},
	actionsAndIncidentRulesDescriptionNonFinal: {
		id: 'eoc-changeboarding.transition-home.deprecated-ones-step.actions-and-incident-rules-description-non-final',
		defaultMessage:
			'Opsgenie actions and incident rules weren’t shifted. You can recreate actions and rules using Jira automation.',
		description: 'Transition home deprecated features step actions and incident rules description',
	},
	reportsTitleNonFinal: {
		id: 'eoc-changeboarding.transition-home.deprecated-ones-step.reports-title-non-final',
		defaultMessage: 'Some reports',
		description: 'Transition home deprecated features step reports',
	},
	reportsDescriptionNonFinal: {
		id: 'eoc-changeboarding.transition-home.deprecated-ones-step.reports-description-non-final',
		defaultMessage:
			'A few reports are not available in Jira Service Management as there are either not supported or are replaced by new reports.',
		description: 'Transition home deprecated features step reports description',
	},
	oecTitleNonFinal: {
		id: 'eoc-changeboarding.transition-home.deprecated-ones-step.oec-title-non-final',
		defaultMessage: 'Opsgenie Edge Connector',
		description: 'Transition home deprecated features step OEC',
	},
	oecDescriptionNonFinal: {
		id: 'eoc-changeboarding.transition-home.deprecated-ones-step.oec-description-non-final',
		defaultMessage:
			// eslint-disable-next-line @atlassian/tangerine/i18n/messages-are-spelled-correctly
			'Your existing OEC integrations will continue to work in Jira. You can create new integrations and actions with the new Jira Edge Connector.',
		description: 'Transition home deprecated features step OEC description',
	},
	servicesTitleNonFinal: {
		id: 'eoc-changeboarding.transition-home.deprecated-ones-step.services-title-non-final',
		defaultMessage: 'External services',
		description: 'Transition home deprecated features step services',
	},
	servicesDescriptionNonFinal: {
		id: 'eoc-changeboarding.transition-home.deprecated-ones-step.services-description-non-final',
		defaultMessage:
			'It’s not possible to create an external service in Jira. You can simply add stakeholders to your services or incidents instead.',
		description: 'Transition home deprecated features step services description',
	},
	tooltipTextNonFinal: {
		id: 'eoc-changeboarding.transition-home.deprecated-ones-step.tooltip-text-non-final',
		defaultMessage: 'Go to documentation',
		description: 'Transition home deprecated features step tooltip text',
	},
});
